import { createReducer } from 'typesafe-actions';
import { TOmjsActions, omjsActions as A } from './omjs-reducer-actions';

export interface IOmjsState {
    omjsViewInstance: omjs.View;
}

const defaultState: IOmjsState = {
    omjsViewInstance: null
};

export const omjsReducer = createReducer<IOmjsState, TOmjsActions>(defaultState)
    .handleAction(A.setViewInstance, (state, action) => ({ ...state, omjsViewInstance: action.payload }));
